import { isEtfOverlapReference } from "@features/etf-overlap/utils/buildEtfOverlapChatMessage";
import { themePackSlugFromReference } from "./themePackChatContext";

/**
 * 「延迟交接」协议行的统一识别：Chat 以 `autoSubmit=false` + 协议行打开时，
 * 先显示同步状态卡，等持仓同步好再把协议行真正发出（EDG-561 FD-7）。
 *
 * - `theme_pack`：资料包 Ed 入口（既有，`themePackSlugFromReference`）
 * - `etf_overlap`：ETF 重叠分析的连账户回流
 */
export type ChatHandoff =
  | { kind: "theme_pack"; slug: string }
  | { kind: "etf_overlap" };

export function resolveChatHandoff(
  question?: string | null,
): ChatHandoff | null {
  const slug = themePackSlugFromReference(question);
  if (slug) {
    return { kind: "theme_pack", slug };
  }
  if (isEtfOverlapReference(question)) {
    return { kind: "etf_overlap" };
  }
  return null;
}
